module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.bf33c166.png";